import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/prisoner-location';

export default {
  getAllLocations(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}${queryString}`);
  },
  createLocation(location) {
    return axios.post(`${base}/create`, { location });
  },
  updateLocation(locationId, location) {
    return axios.post(`${base}/update/${locationId}`, { location });
  },
  deleteLocation(locationId) {
    return axios.delete(`${base}/delete/${locationId}`);
  },
};
